import { Link } from 'react-router-dom';
import { Bed, Bath, Ruler } from 'lucide-react';
import { PoweredByRealtor } from './CreaCompliance';

export function ListingCard({ listing }) {
  const photo = listing.photos?.[0]?.medium || listing.photos?.[0]?.thumbnail || null;
  const price = listing.price ? `$${listing.price.toLocaleString()}` : 'Price TBD';
  const beds = listing.building?.bedrooms || 0;
  const baths = listing.building?.bathrooms || 0;
  const sqft = listing.building?.size_interior || null;
  const addr = listing.address || {};
  const street = addr.street || `${addr.street_number || ''} ${addr.street_name || ''}`.trim();
  const category = listing.property_category;

  return (
    <Link
      to={`/listing/${listing.mls_number}`}
      className="group bg-white rounded-2xl border border-slate-200/80 overflow-hidden card-interactive"
      data-testid={`listing-card-${listing.mls_number}`}
    >
      {/* Photo */}
      <div className="aspect-[4/3] bg-slate-100 relative overflow-hidden">
        {photo ? (
          <img src={photo} alt={street} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-slate-300">No Photo</div>
        )}
        {category && (
          <span className="absolute top-3 left-3 text-[10px] font-semibold uppercase tracking-wider bg-white/90 backdrop-blur-sm text-slate-700 px-2.5 py-1 rounded-full">
            {category}
          </span>
        )}
      </div>
      {/* Details */}
      <div className="p-4">
        <p className="font-mono text-lg font-bold text-slate-900 mb-1">{price}</p>
        <p className="text-sm text-slate-700 font-medium truncate">{street || 'Address on request'}</p>
        <p className="text-xs text-slate-400 mb-3">{addr.city || 'Burlington'}, ON {addr.postal_code || ''}</p>
        <div className="flex items-center gap-4 text-xs text-slate-500 mb-3">
          {beds > 0 && <span className="flex items-center gap-1"><Bed className="w-3.5 h-3.5" />{beds} bed</span>}
          {baths > 0 && <span className="flex items-center gap-1"><Bath className="w-3.5 h-3.5" />{baths} bath</span>}
          {sqft && <span className="flex items-center gap-1"><Ruler className="w-3.5 h-3.5" />{sqft}</span>}
        </div>
        {/* Brokerage attribution */}
        {listing.agent?.office && (
          <p className="text-[10px] text-slate-400 mb-2 truncate">Listed by {listing.agent.office}</p>
        )}
        <div className="flex items-center justify-between pt-3 border-t border-slate-100">
          <span className="text-[10px] font-mono text-slate-400">MLS® {listing.mls_number}</span>
          <span onClick={e => { e.preventDefault(); if (listing.more_info_link) window.open(listing.more_info_link, '_blank'); }}>
            <PoweredByRealtor moreInfoLink={null} className="h-5 opacity-60 hover:opacity-100 transition-opacity" />
          </span>
        </div>
      </div>
    </Link>
  );
}

export function ListingCardSkeleton() {
  return (
    <div className="bg-white rounded-2xl border border-slate-200/80 overflow-hidden animate-pulse">
      <div className="aspect-[4/3] bg-slate-100" />
      <div className="p-4 space-y-2">
        <div className="h-5 bg-slate-100 rounded w-1/3" />
        <div className="h-4 bg-slate-50 rounded w-2/3" />
        <div className="h-3 bg-slate-50 rounded w-1/2" />
      </div>
    </div>
  );
}
